export const STATE_PROP = 'machines';
